import { BehaviorSubject } from 'rxjs';

export class CoreConstants {
  public static firstPageOriginal = '/dashboard';
  public static firstPage = '/dashboard';
  public static ADMIN_LANDING_PAGE = '/configuration';
  public static excludeDomainUrl: string[] = [];
  public static appName = 'HP';
  public static domain = 'HP';
  public static socketEnabled = false;
  public static timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  public static API: any = {
    userProfile: '/application/user/v1/user_details',
    userProfile_Enc: '/application/user/v1/genneigjegnklgnekl',
    self_singUp: '/user/v1/self_signup',
    getOrgByAlias: '/organisation/v1/getByAlias/',
    getOrgRoles: '/application/user/v1/user_details',
    getOrgRoles_Enc: '/application/user/v1/genneigjegnklgnekl',
    getOrgUserList: '/organisation/v1/admin/get_user',
    getOrgRoleList: '/organisation/role/v1/get',
    getChangePassword: '/user/v1/change_password',
    update_email: '/user/v1/update_email',
    getUserPrefs: '/artemis_preference/v1/get',
    updateUserProfile: '/user/v1/update_profile',
    setDefaultWorkspace: '/artemis_preference/v1/default-workspace',

  };

  static allowedPages: string [] = ['/dashboard/overview'];
  static allowedMenus: string [] = ['dashboard'];
  static allowSocialLogin = false;
  static passwordLessUI = false;
  static allowedSocialLogin: { google?: boolean, facebook?: boolean } = {};
  static rightMask$: BehaviorSubject<{}> = new BehaviorSubject(null);
  static externalPoliciesLink = {
    termsAndCondition: 'https://www.hivepro.com/terms-conditions/',
    securityPolicy: 'https://www.hivepro.com/information-security-policy/',
    privacyPolicy: 'https://www.hivepro.com/privacy-policy/',
    contactUs: 'https://www.hivepro.com/contact-us/',
  };
  static encryptionKey: string;
  static encryptionIV: string;
  public static applicationDetails = {
    appName: 'HiTech',
    version: '1.0.0'
  };

  public static networkLogModules = {
    network_log_widget: 'NetworkLog',
    network_log_widget_15min: 'NetworkLog15Min',
    network_log_widget_1hour: 'NetworkLog1Hour',
    network_log_widget_1day: 'NetworkLog1Day',
    plant_log_5_min: 'PlantLog5Min',
    plant_log_widget_15min: 'PlantLog15Min',
    plant_log_widget_1hour: 'PlantLog1Hour',
    plant_log_widget_1day: 'PlantLog1Day',
  };

  constructor() {
  }
}

export class AppSettingsProto {
  logoPath: string;
  title: string;
  appName: string;
  favicon: string;
}

export class PaginationProto {
  skip: number;
  take: number;
  total: number;
}

export interface DefaultStatusResponse {
  code: number;
  message: string;
  cause: string;
}

export class PaginationRequest {
  pageNumber: number;
  pageSize: number;
  sort: SortRequestProto[];
}

export class SortRequestProto {
  direction: 'ASC' | 'DESC';
  property: string;
}


export interface ListResponse<T> {
  list: T[];
  totalRecords: number;
}

export interface DefaultListResponse<T> {
  result: T[];
  totalRecords: number;
}

export const DEFAULT_DATE_FORMAT = 'MMM d, yyyy';
export const DEFAULT_DATE_TIME_FORMAT = DEFAULT_DATE_FORMAT + ' h:mm:ss a';
export const pageSizes = [5, 10, 25, 50, 100];

export class DefaultMetaData {
  createdByName?: string;
  createdOn?: Date;
  modifiedBy?: string;
  modifiedOn?: Date;
}

export class DefaultAccessModel {
  RD: boolean;
  CR: boolean;
  ED: boolean;
  DEL: boolean;

  [key: string]: boolean;
}


export enum PREFERENCE_TYPE {
  internal = 'INTERNAL_VIEW',
  org = 'ORG_VIEW',
}


export interface EncryptedResponse extends DefaultStatusResponse {
  response: string;
}

export enum PENTESTER_ROLE {
  techManager = 'TECH_MANAGER',
  leadPentester = 'LEAD_PENTESTER',
  pentester = 'PENTESTER',
}

export class ExportRequest {
  additionalInfo: ExportAdditionalInfo;
  moduleName: string;
  fileType: string;
}

export class ExportAdditionalInfo {
  request: any;
  type?: string;
  subType?: string;
  timeZone: string;
  moduleName?: string;
}

export enum EXPORT_FILE_TYPE {
  excel = 'EXCEL',
  pdf = 'PDF',
}

export const AliasPattern = '^[a-zA-Z0-9_]{1,15}$';
